import { Counter, TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';

const TeamSearchTitle = ({
  myTeamsOnly,
  underMinSearchLength,
  searchTerm,
}: {
  myTeamsOnly: boolean;
  underMinSearchLength: boolean;
  searchTerm: string;
}) => {
  const { t } = useTranslation();

  if (myTeamsOnly) {
    return underMinSearchLength
      ? t('ui.event-management.learners.my-teams.heading-default')
      : t('ui.event-management.learners.my-teams.heading', {
          searchTerm,
        });
  }

  return searchTerm
    ? t('ui.event-management.learners.filtered-teams', {
        searchTerm,
      })
    : t('ui.event-management.learners.all-teams');
};

const TeamTitleCounter = ({
  isFetched,
  myTeamsOnly = false,
  underMinSearchLength,
  items,
  searchTerm,
  count,
}: {
  isFetched: boolean;
  myTeamsOnly?: boolean;
  underMinSearchLength: boolean;
  items: unknown[];
  searchTerm: string;
  count?: number;
}): string | JSX.Element => {
  const { t } = useTranslation();

  if (!isFetched && items.length === 0) {
    return t('ui.event-management.learners.teams.list.no-search-term');
  }

  return (
    <TextV2 component="h2" variant="h3">
      <TeamSearchTitle
        myTeamsOnly={myTeamsOnly}
        underMinSearchLength={underMinSearchLength}
        searchTerm={searchTerm}
      />
      &nbsp;
      <Counter count={count ?? items?.length ?? 0} size="large" />
    </TextV2>
  );
};

export default TeamTitleCounter;
